import { MenuItem } from './menu.model';

export const MENU: MenuItem[] = [
    {
        id: 1,
        label: 'MENUITEMS.MENU.TEXT',
        isTitle: true
    },
    {
        id: 2,
        label: 'MENUITEMS.DASHBOARDS.TEXT',
        icon: 'bx-home-circle',
        link: '/',
    },
    {
        id: 3,
        label: 'Meu Arquivos',
        icon: 'bx-file',
        link: '/filemanager',
    },
    {
        id: 4,
        label: 'Grupos de Usuário',
        icon: 'bx-user',
        link: '/grupousuario',
    },
    {
      id: 5,
      label: 'Sair',
      icon: 'bx-log-out',
      funcaoSair: true,
  },
];

